import React from 'react';
import { Container } from '@worthy-npm/worthy-common-ui-components';

const LayoutViews: React.FC<React.PropsWithChildren<{}>> = (props) => {
  if (!props.children) {
    return null;
  }

  return (
    <Container
      maxWidth="xl"
      sx={{
        marginTop: '40px',
        marginBottom: '40px',
        maxWidth: '1000px',
        paddingLeft: 0,
        paddingRight: 0,
        '@media (min-width: 600px)': {
          padding: 0,
        },
      }}
    >
      {props.children}
    </Container>
  );
};

export default LayoutViews;
